import { render, staticRenderFns } from "./TextToImage.vue?vue&type=template&id=fa3ce5fa&lang=pug"
import script from "./TextToImage.vue?vue&type=script&lang=js"
export * from "./TextToImage.vue?vue&type=script&lang=js"
import style0 from "./TextToImage.vue?vue&type=style&index=0&id=fa3ce5fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports